import sa from "@/utils/sensorsdata.es6.full.js"
let gcTrack = Object.create(null);
let methodList = ['quick', 'register', 'registerPage', 'registerOnce', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'logout', 'trackLink', 'clearAllRegister', 'getAppStatus'];
let isInit = false;
gcTrack.init = function (para) {
  isInit = true;
  sa.init(para);
}
gcTrack.login = function (id) {
  isInit = true;
  sa.login(id);
}
gcTrack.identify = function(id){
  isInit = true;
  sa.identify(id, true)
}
gcTrack.track = function (e, p, c) {
  if (isInit) {
    try {
      sa.track(e, p, c);
    } catch (e) { }
  }
}
methodList.forEach((n, i) => {
  gcTrack[n] = sa[n];
})
export default gcTrack;



// WEBPACK FOOTER //
// ./src/utils/gcTrack.js